

class Utils {
  deepObjectCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
}

const utilInstance = new Utils();
export default utilInstance;